import { render } from "./TokensList.vue?vue&type=template&id=5ee90f5f"
import script from "./TokensList.vue?vue&type=script&lang=js"
export * from "./TokensList.vue?vue&type=script&lang=js"

import "./TokensList.vue?vue&type=style&index=0&id=5ee90f5f&lang=scss"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__